export interface Rates {
  currency: string;
  info: RateInfo[];
}

export interface RateInfo {
  from: string;
  to: string;
  toName: string;
  value: number;
}

export enum ChangeType {
  decrease,
  increase,
}
